<template>
  <div>
    <div>
      <!-- 标题 -->
      <ots-main-title></ots-main-title>
      <!-- 卡片 -->
      <div class="card-container">
        <div class="card-item">
          <div class="card-label">考试批次</div>
          <div class="card-value">{{ ruleInfo.planName || '--' }}</div>
        </div>
        <div class="card-item">
          <div class="card-label">课程名称</div>
          <div class="card-value">{{ ruleInfo.courseName || '--' }}</div>
        </div>
        <div class="card-item">
          <div class="card-label">实考人数</div>
          <div class="card-value">{{ ruleInfo.examedCount || 0 }}</div>
        </div>
        <div class="card-item">
          <div class="card-label">原始分大区间</div>
          <div class="card-value">{{ ruleInfo.oriScoreMin || 0 }} - {{ ruleInfo.oriScoreMax || 0 }}</div>
        </div>
      </div>
      
      <!-- 赋分规则表单 -->
      <div class="form-container">
        <h3 class="form-title">设置赋分规则</h3>
        <el-form :model="scoredRuleForm" label-width="120px">
          <!-- 赋分区间设置 -->
          <el-form-item label="赋分区间">
            <div class="score-range">
              <span class="range-label">&nbsp;</span>
              <el-input-number
                v-model="scoredRuleForm.scoreRangeMin"
                :min="0"
                :max="100"
                :step="1"
                style="width: 240px"
                controls-position="right"
                placeholder="下限"
              ></el-input-number>
              <span class="range-separator">-</span>
              <el-input-number
                v-model="scoredRuleForm.scoreRangeMax"
                :min="0"
                :max="100"
                :step="1"
                style="width: 240px"
                controls-position="right"
                placeholder="上限"
              ></el-input-number>
            </div>
          </el-form-item>
          
          <!-- 等级人数比例设置 -->
          <el-form-item label="各等级人数比例">
            <div class="grade-list">
              <div v-for="(grade, index) in scoredRuleForm.gradeList" :key="index" class="grade-item">
                <span class="grade-label">{{ String.fromCharCode(65 + index) }}</span>
                <el-input-number
                  v-model="grade.percent"
                  :min="1"
                  :max="100"
                  :step="1"
                  style="width: 240px"
                  controls-position="right"
                  placeholder="占比"
                ></el-input-number>
                <span class="percent-symbol">%</span>
                <el-button
                  v-if="scoredRuleForm.gradeList.length > 2"
                  type="danger"
                  size="small"
                  @click="removeGrade(index)"
                >
                  删除
                </el-button>
              </div>
              <el-button type="primary" size="small" @click="addGrade" style="width: 240px; margin-left: 20px;">
                添加等级
              </el-button>
            </div>
            <div class="total-percent" v-if="scoredRuleForm.gradeList.length > 0">
              总占比: {{ totalPercent }}%
              <span v-if="totalPercent !== 100" class="percent-warning">(需调整为100%)</span>
            </div>
            <div class="remark-content" v-if="scoredRuleForm.gradeList.length > 0">
              说明：实际计算结果可能因人数比例调整而略有误差。
            </div>
          </el-form-item>
          
          <!-- 保存按钮 -->
          <el-form-item>
            <el-button type="primary" @click="saveRule" :disabled="totalPercent !== 100">保存规则</el-button>
            <!-- 保存成功后显示的按钮 -->
            <el-button v-if="saveSuccess" type="success" @click="executeScoring" :disabled="executing || executed">
              {{ executing ? '执行中...' : '执行赋分计算' }}
            </el-button>
            <el-button @click="goBack">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <!-- 赋分计算结果 -->
      <div v-if="executed" class="result-container">
        <!-- 赋分计算结果表格 -->
        <div class="result-section">
          <h3 class="result-title">赋分计算结果</h3>
          <div class="result-note">计算说明：赋分区间长度=（赋分上限 - 赋分下限） x 该等级比例</div>
          <el-table :data="scoredDetailList" border style="width: 100%">
            <el-table-column prop="gradeName" label="等级" align="center"></el-table-column>
            <el-table-column prop="gradePercent" label="人数比例" align="center"></el-table-column>
            <el-table-column prop="studentCount" label="实际人数" align="center"></el-table-column>
            <el-table-column label="原始分区间" align="center">
              <template slot-scope="scope">
                {{ scope.row.oriScoreMin }} - {{ scope.row.oriScoreMax }}
              </template>
            </el-table-column>
            <el-table-column label="赋分区间" align="center">
              <template slot-scope="scope">
                {{ scope.row.scoredMin }} - {{ scope.row.scoredMax }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        
        <!-- 赋分明细预览 -->
        <div class="result-section">
          <div class="result-header">
            <h3 class="result-title">赋分明细预览</h3>
            <el-button type="primary" size="small" @click="exportScoredList">导出</el-button>
          </div>
          <el-table :data="scoredStudentList" border style="width: 100%">
            <el-table-column prop="realName" label="学生姓名" align="center"></el-table-column>
            <el-table-column prop="cardNo" label="证件号" align="center"></el-table-column>
            <el-table-column prop="courseName" label="课程名称" align="center"></el-table-column>
            <el-table-column prop="oriScore" label="原始分" align="center"></el-table-column>
            <el-table-column prop="rowNumber" label="排名" align="center"></el-table-column>
            <el-table-column prop="gradeName" label="所在等级" align="center"></el-table-column>
            <el-table-column label="所在原始分区间" align="center">
              <template slot-scope="scope">
                {{ scope.row.oriScoreMin }} - {{ scope.row.oriScoreMax }}
              </template>
            </el-table-column>
            <el-table-column label="所在赋分区间" align="center">
              <template slot-scope="scope">
                {{ scope.row.scoredMin }} - {{ scope.row.scoredMax }}
              </template>
            </el-table-column>
            <el-table-column prop="scoredValue" label="赋分结果" align="center"></el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="pagination-container" v-if="scoredStudentPagination.total > 0">
            <el-pagination
              background
              layout="prev, pager, next, jumper, sizes, total"
              :total="scoredStudentPagination.total"
              :page-size="scoredStudentPagination.size"
              :page-sizes="[10, 20, 50, 100]"
              :current-page="scoredStudentPagination.page"
              @size-change="changeScoredStudentSize"
              @current-change="changeScoredStudentPage"
            />
          </div>
          <!-- 赋分结果确认按钮 -->
          <!-- 
          <div class="confirm-container">
            <el-button type="primary" @click="confirmScoredResult" :disabled="confirming || confirmed">
              {{ confirming ? '确认中...' : '赋分结果确认' }}
            </el-button>
          </div> 
          -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {   
    getScoredRuleInfoBySetIdFn, 
    getScoredRuleBySetIdFn,
    scoredRuleSaveFn,
    scoredRuleExecuteFn,
    getScoredDetailBySetIdFn,
    getScoredStudentListBySetIdFn,
    getScoredStudentListBySetIdExportFn,
    confirmScoredRuleBySetIdFn
} from '@/http/modules/examSet/scoringRuleSet';

export default {
    name: 'scoringRuleSet',
    data() {
        return {
            ruleInfo: {
                planName: '',
                courseName: '',
                examedCount: 0,
                oriScoreMin: 0,
                oriScoreMax: 0
            },
            scoredRuleForm: {
                setId: '',
                scoreRangeMin: 0,
                scoreRangeMax: 100,
                gradeList: [
                    { percent: 50 },
                    { percent: 50 }
                ]
            },
            // 保存状态
            saveSuccess: false,
            // 执行赋分计算状态
            executing: false,
            executed: false,
            // 确认赋分结果状态
            confirming: false,
            confirmed: false,
            // 赋分计算结果
            scoredDetailList: [],
            // 赋分明细
            scoredStudentList: [],
            scoredStudentPagination: {
                total: 0,
                page: 1,
                size: 10
            }
        }
    },
    computed: {
        // 计算总占比
        totalPercent() {
            return this.scoredRuleForm.gradeList.reduce((total, grade) => total + (grade.percent || 0), 0);
        }
    },
    created() {
        this.getRuleInfo();
        this.getRule();
    },
    methods: {
        /**
         * 1、  查询某个setId的赋分规则的统计详情
         * 2、  查询某个setId的赋分规则
         * 3、  保存赋分规则
         * 4、  执行赋分规则
         * 5、  执行赋分规则后，查询各等级的统计信息
         * 6、  执行赋分规则后，查询各等级的学生清单
         * 7、  执行赋分规则后，查询各等级的学生清单,导出
         * 8、  确定使用赋分结果（单个设置）
         */
        
        /**
         * 获取赋分规则信息
         */
        async getRuleInfo() {
            // 从路由参数中获取setId
            const setId = this.$route.query.setId || '';
            if (setId) {
                try {
                    const { data } = await getScoredRuleInfoBySetIdFn({ setId });
                    this.ruleInfo = data || {
                        planName: '',
                        courseName: '',
                        examedCount: 0,
                        oriScoreMin: 0,
                        oriScoreMax: 0
                    };
                } catch (error) {
                    console.error('获取赋分规则信息失败:', error);
                }
            }
        },
        
        /**
         * 获取赋分规则
         */
        async getRule() {
            // 从路由参数中获取setId
            const setId = this.$route.query.setId || '';
            this.scoredRuleForm.setId = setId;
            
            if (setId) {
                try {
                    const { data } = await getScoredRuleBySetIdFn({ setId });
                    if (data) {
                        this.scoredRuleForm.scoreRangeMin = data.scoreRangeMin || 0;
                        this.scoredRuleForm.scoreRangeMax = data.scoreRangeMax || 100;
                        
                        // 处理等级占比
                        if (data.gradePercents) {
                            const percents = data.gradePercents.split(',').map(p => parseInt(p) || 0);
                            this.scoredRuleForm.gradeList = percents.map(percent => ({ percent }));
                        }
                    }
                } catch (error) {
                    console.error('获取赋分规则失败:', error);
                }
            }
        },
        
        /**
         * 添加等级
         */
        addGrade() {
            if (this.scoredRuleForm.gradeList.length < 5) {
                this.scoredRuleForm.gradeList.push({ percent: 0 });
            } else {
                this.$message.warning('等级数量最多为5个');
            }
        },
        
        /**
         * 删除等级
         */
        removeGrade(index) {
            if (this.scoredRuleForm.gradeList.length > 2) {
                this.scoredRuleForm.gradeList.splice(index, 1);
            } else {
                this.$message.warning('等级数量最少为2个');
            }
        },
        
        /**
         * 保存规则
         */
        async saveRule() {
            if (this.totalPercent !== 100) {
                this.$message.warning('总占比必须为100%');
                return;
            }
            
            try {
                // 准备保存数据
                const saveData = {
                    setId: this.scoredRuleForm.setId,
                    scoreRangeMin: this.scoredRuleForm.scoreRangeMin,
                    scoreRangeMax: this.scoredRuleForm.scoreRangeMax,
                    gradePercents: this.scoredRuleForm.gradeList.map(g => g.percent).join(',')
                };
                
                const { code, message } = await scoredRuleSaveFn(saveData);
                if (code) {
                    this.$message.success('保存成功');
                    this.saveSuccess = true;
                    // 保存成功后重置执行状态，允许再次执行
                    this.executed = false;
                    this.confirmed = false;
                } else {
                    this.$message.error(message || '保存失败');
                }
            } catch (error) {
                console.error('保存赋分规则失败:', error);
                this.$message.error('保存失败');
            }
        },
        
        /**
         * 返回
         */
        goBack() {
            this.$router.back();
        },
        
        /**
         * 执行赋分计算
         */
        async executeScoring() {
            this.executing = true;
            try {
                // 添加1.5秒延迟，让用户看到执行中的状态
                await new Promise(resolve => setTimeout(resolve, 1500));
                
                const { code, message } = await scoredRuleExecuteFn({ setId: this.scoredRuleForm.setId });
                if (code) {
                    this.$message.success('执行成功');
                    this.executed = true;
                    this.confirmed = false;
                    // 获取计算结果
                    await this.getScoredDetail();
                    await this.getScoredStudentList();
                //} else {
                //    this.$message.error(message || '执行失败');
                }
            } catch (error) {
                console.error('执行赋分计算失败:', error);
                this.$message.error('执行失败');
            } finally {
                this.executing = false;
            }
        },
        
        /**
         * 获取赋分计算结果
         */
        async getScoredDetail() {
            try {
                const { data } = await getScoredDetailBySetIdFn({ setId: this.scoredRuleForm.setId });
                this.scoredDetailList = data || [];
            } catch (error) {
                console.error('获取赋分计算结果失败:', error);
            }
        },
        
        /**
         * 获取赋分明细
         */
        async getScoredStudentList() {
            try {
                const { data } = await getScoredStudentListBySetIdFn({
                    setId: this.scoredRuleForm.setId,
                    page: this.scoredStudentPagination.page,
                    size: this.scoredStudentPagination.size
                });
                this.scoredStudentList = data.records || [];
                this.scoredStudentPagination.total = data.total || 0;
            } catch (error) {
                console.error('获取赋分明细失败:', error);
            }
        },
        
        /**
         * 改变赋分明细分页大小
         */
        changeScoredStudentSize(size) {
            this.scoredStudentPagination.size = size;
            this.getScoredStudentList();
        },
        
        /**
         * 改变赋分明细分页页码
         */
        changeScoredStudentPage(page) {
            this.scoredStudentPagination.page = page;
            this.getScoredStudentList();
        },
        
        /**
         * 导出赋分明细
         */
        async exportScoredList() {
            try {
                const { data, code } = await getScoredStudentListBySetIdExportFn({ setId: this.scoredRuleForm.setId });
                if (code) {
                    window.open(data);
                }
            } catch (error) {
                console.error('导出赋分明细失败:', error);
                this.$message.error('导出失败');
            }
        },
        
        /**
         * 确认赋分结果
         */
        async confirmScoredResult() {
            this.confirming = true;
            try {
                const { code, message } = await confirmScoredRuleBySetIdFn({ setId: this.scoredRuleForm.setId });
                if (code) {
                    this.$message.success('确认成功');
                    this.confirmed = true;
                } else {
                    this.$message.error(message || '确认失败');
                }
            } catch (error) {
                console.error('确认赋分结果失败:', error);
                this.$message.error('确认失败');
            } finally {
                this.confirming = false;
            }
        }
    }
}

</script>

<style lang="less" scoped>
.card-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-top: 20px;
  padding: 0 20px;
}

.card-item {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
  
  .card-label {
    font-size: 14px;
    color: #606266;
    margin-bottom: 10px;
  }
  
  .card-value {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
  }
}

.form-container {
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 0 20px;
  
  .form-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e4e7ed;
  }
  
  .score-range {
    display: flex;
    align-items: center;
    
    .range-separator {
      margin: 0 10px;
      color: #606266;
    }
    .range-label {
        font-size: 14px;
        color: #606266;
        width: 20px;
    }
  }
  
  .grade-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
    
    .grade-item {
      display: flex;
      align-items: center;
      gap: 10px;
      
      .grade-label {
        font-size: 14px;
        color: #606266;
        width: 10px;
      }
      
      .percent-symbol {
        font-size: 14px;
        color: #606266;
        margin-left: 5px;
      }
    }
  }
  
  .total-percent {
    margin-top: 15px;
    font-size: 14px;
    color: #606266;
    
    .percent-warning {
      color: #f56c6c;
      margin-left: 10px;
    }
  }

  .remark-content{
    color:  #f56c6c;
  }
}

.result-container {
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 0 20px;
}

.result-section {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
  
  .result-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .result-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 15px;
  }
  
  .result-note {
    font-size: 14px;
    color: #606266;
    margin-bottom: 20px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
  
  .el-table {
    margin-bottom: 20px;
    
    th {
      background-color: #f5f7fa;
      font-weight: 600;
      color: #303133;
    }
    
    tr:hover {
      background-color: #f5f7fa;
    }
  }
  
  .confirm-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
}

/* 分页样式保持一致 */
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  padding: 15px;
  background-color: #ffffff;
  border-radius: 1px;
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.1);
  
  .el-pagination {
    display: flex;
    align-items: center;
    
    /deep/.el-pagination__sizes {
      width: 140px;
      margin-right: 15px;
      .el-input {
        width: 140px;
      }
      .el-input__inner {
        width: 140px;
      }
    }
    
    
    /deep/.el-pagination__jump {
      width: 140px;
      margin-left: 15px;

      .el-input__inner {
        width: 90px;
      }
    }
    
    .el-pagination__total {
      margin-right: 15px;
      font-size: 14px;
      color: #606266;
    }
    
    .el-pagination__btn {
      border-radius: 4px;
      transition: all 0.3s;
      
      &:hover {
        color: #409eff;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
      }
    }
    
    .el-pager li {
      border-radius: 4px;
      margin: 0 4px;
      transition: all 0.3s;
      
      &:hover {
        color: #409eff;
      }
      
      &.active {
        background-color: #409eff;
        color: #fff;
        border-color: #409eff;
      }
    }
  }
}
</style>